<template lang="html">
    <div class="form-group radio" style="width=100%">
      <div v-html="question.title" class="col-form-label pt-0 form-group" style="padding-bottom: 0.50rem;text-align: justify; padding-right: 0.9rem;"></div>
      <b-form-group>
        <b-form-radio-group
          v-model="selected"
          :options="options_formatted"
          name="radioOpenions"
          v-if="options_formatted.length < 6"
          @input="changeStep()"
        > </b-form-radio-group>
        <b-row v-else >
          <b-col
            sm="12"
            md="6"
            v-for="item in options_formatted" :key="item.key"
            >
              <b-form-radio
                v-model="selected"
                :value="item.value"
                @input="changeStep()">
                <span> {{item.text}} </span>
              </b-form-radio>
          </b-col>
        </b-row>
      </b-form-group>
    </div>
</template>

<script>

export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    defaultValue: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      selected: null,
      options_formatted: [],
    };
  },
  watch: {
    // whenever question changes, this function will run
    question: function (newVal, oldVal) { // watch it
      this.updateValues();
      this.setDefaultValue();
    }
  },
  mounted () {
    this.updateValues();
    this.setDefaultValue();
  },
  methods: {
    // 
    changeStep () {
      /* send object and with value, next Question id and previus, and set value in json reactive */ 
      this.question.options_values = [];
      this.question.options_values[0] = this.selected.value;
      this.$emit('change-step', this.selected);
    },
    updateValues () {
      this.options_formatted = [];
      for (let i = 0; i < this.question.options.length; i++) {
        const option = this.question.options[i];
        this.options_formatted.push({
          value: { 
            value: option.id, 
            nextQuestionId: this.question.options[i].next_question_id, 
            previusQuestionId: this.question.options[i].previus_question_id
          },
          text: option.title
        });
      }      
    },
    setDefaultValue () {
      let _self = this;
      if (this.defaultValue !== null) {
        let selectDefaultValue = this.options_formatted.filter(function (option) {
          return option.value.value === _self.defaultValue;
        });
        this.selected = selectDefaultValue[0].value;
        this.question.options_values = [];
        this.question.options_values[0] = this.selected.value;
      } else {
        this.selected = this.options_formatted[0].value;
        this.question.options_values = [];
        this.question.options_values[0] = this.selected.value;
      }
      this.changeStep();
    }
  }
};
</script>
<style lang="css">
  .radio .custom-control-label, .radio .col-form-label{
    font-size: 20px;
    font-weight: bold;
    padding-left: 4px;
    margin-left: 8px;
  }
  .radio .custom-control-label span{
    margin-top: 2rem;
  }
  .radio .custom-control-label::after {
    left: -1.47rem;
  }
  .radio .custom-control-label::before, .radio .custom-control-label::after {
    top: 6px;
    width: 1.25rem;
    height: 1.25rem;
  }
  .radio .custom-control {
      width: 100%;
      display: block;
    }
  .radio .custom-control + .custom-control{
    margin-top: 8px;
  }
  .radio .custom-control .custom-control-label {
    display: block;
    margin: 0 auto;
    text-align: left;
    font-weight: 400;
  }
  .radio .custom-control .custom-control-label span{
      font-size: 18px;
      font-weight: 300;
    }
  @media screen and (max-width: 768px){
    .radio .custom-control {
      width: 100%;
      display: block;
    }
    .radio .custom-control + .custom-control{
      margin-top: 8px;
    }
    .radio .custom-control .custom-control-label {
      display: block;
      margin: 0 auto;
      text-align: left;
      margin-left: 10px !important;
    }
    .radio .custom-control .custom-control-label span{
      font-size: 14px;
      font-weight: 300;
    }
    
  }
  @media only screen and (orientation: portrait) and (max-width: 475px)  {
    .radio .custom-control-label, .radio .col-form-label{
      font-size: 14px;
      font-weight: bold;
    }
    .center-title {
      display: block; 
      margin-left: auto; 
      margin-right: auto;
      float: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/surveys/v2/components/Radio.vue